<template>
  <div :style="Mode == 'Immersive' ? '' : 'height:100%; overflow:auto; background:white;'">
    <vs-popup title="Revision history" :active.sync="ShowRevisionHistory" fullscreen>
      <div v-if="RevisionHistoryItems && RevisionHistoryItems.length > 0">
        <vs-table ref="table" :data="RevisionHistoryItems">
          <template slot="thead">
            <vs-th style="width:40px" sort-key="State">State</vs-th>
            <vs-th></vs-th>
            <vs-th sort-key="FullName">User</vs-th>
            <vs-th>Version</vs-th>
            <vs-th sort-key="Comment">Comment</vs-th>
            <vs-th>
              Actions
            </vs-th>
          </template>

          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :class="tr.state" :data="tr" :key="'rvItem_' + indextr"
                v-for="(tr, indextr) in RevisionHistoryItems">
                <vs-td style="text-align:center; vertical-align:top; v-align:top;">
                  <FeatherIcon v-if="tr.State && tr.State.toLowerCase() == 'draft'"
                    style="color:orange; border-radius:50%; padding:5px;" icon="EditIcon"></FeatherIcon>
                  <FeatherIcon v-if="tr.State && tr.State.toLowerCase() == 'published'"
                    style="color:#3bb468; border-radius:50%; padding:5px;" icon="CheckSquareIcon"></FeatherIcon>
                  <br />
                  <span style="font-size:10px;">{{ tr.State }}</span>
                </vs-td>
                <vs-td style="v-align: top; vertical-align: top">
                  <UserAvatar :userProfile="tr.CreatedForUser" size="24px" color="primary" styleProp="float:left;">
                  </UserAvatar>
                </vs-td>
                <vs-td style="v-align: top; vertical-align: top">
                  <p class="product-name font-medium">
                    {{ tr.CreatedForUser.FirstName }}
                    {{ tr.CreatedForUser.LastName }}
                    <small><small><strong>{{ tr.AssignmentType }}</strong></small></small><br /><span
                      style="font-size: 9px">{{
    friendlyDate(tr.CreatedOn)
  }}</span>
                  </p>
                </vs-td>
                <vs-td style="v-align: top; vertical-align: top">
                  {{ tr.Version }}
                </vs-td>
                <vs-td style="v-align: top; vertical-align: top">
                  {{ tr.Comment }}
                </vs-td>
                <vs-td style="v-align: top; vertical-align: top">
                  <a @click="window.alert('Comming soon.')">
                    Load in editor
                  </a>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </div>
      <div v-else>
        No items yet. Saved versions will appear here.
      </div>
    </vs-popup>

    <vs-popup title="Publish" :active.sync="ShowPublishOptions">
      Comments:<br />
      <vs-input v-model="RevisionComment" style="width:100%;"></vs-input><br />
      <vs-checkbox v-model="ResetAssessments">Reset related assessments</vs-checkbox>
      <vs-button color="success" type="gradient" icon-pack="feather" icon="icon-save" @click="PublishRevision()"
        class="mb-3" style="float:right; margin-top:20px;">Save</vs-button>
    </vs-popup>

    <vs-popup title="Share..." style="min-width:400px;" :active.sync="ShowShareOptions">
      <ShareEmbedSteps :EmbedItem="this.ContextMenuItem">

      </ShareEmbedSteps>
    </vs-popup>

    <AssessmentScreen v-if="Mode == 'Assessment' && InternalDetailsItem != null"
      style="position: absolute; width: 100%; height: 100%; background: white; z-index: 9999;"
      :QuestionsToGenerateFor="[InternalDetailsItem]" @ModeChanged="OnModeChanged">
    </AssessmentScreen>

    <a v-if="Mode == 'Assessment'" @click="CloseAssessment()" class="text-danger"
      style="position: fixed;bottom: 20px;right: 20px;font-weight: 900;cursor: pointer;z-index: 9999;">
      Exit assessment
    </a>

    <div class="carousel-example" ref="content" v-if="ContextMenuItem && ContextMenuItem.children">
      <swiper @slideChange="SlideChanged" :options="swiperOption" v-if="Mode === 'Tour'" ref="swiper">
        <swiper-slide ref="slide" class="tiptap" v-for="(swiperItem, swiperIndex) in ContextMenuItem.children"
          :key="swiperIndex">
          <h3 style="font-size: 41px">
            {{ swiperItem.data.Title }}
          </h3>
          <br />
          <div v-html="swiperItem.data.Description"></div>
        </swiper-slide>
        <swiper-slide>
          <div v-if="!CurrentTourQuestionsJSON || CurrentTourQuestionsJSON.length == 0
    ">
            <h3 style="font-weight: 900; font-size: 41px">Hold tight ...</h3>
            <br />
            We are generating some questions to help you identify your
            progress...<br />
            <br />
            <span v-if="GeneratingQuestionsCount">We will come up with about
              {{ GeneratingQuestionsCount }} questions.</span>

            <br />
          </div>
          <div v-else-if="QuestionsAnswered == CurrentTourQuestionsJSON.length" style="width: 320px; margin: 0 auto">
            <img src="@/assets/images/pages/assessment-complete.jpg" alt="Tour complete" class="mx-auto mb-4 max-w-full"
              style="height: 338px; width: 338px" />
            <h1 style="font-weight: 900">You made it!</h1>
            <span style="float: left">Thank you so much for the efforts.</span><br /><br /><br />
            <vs-button @click="
    ResetTourData();
  CurrentTourQuestionsJSON = null;
  $emit('ModeChanged', '');
  ">Close tour</vs-button>
          </div>
          <div v-if="CurrentTourQuestionsJSON &&
    CurrentTourQuestionsJSON.length > 0 &&
    QuestionsAnswered < CurrentTourQuestionsJSON.length
    ">
            <div v-for="(question, questionIdx) in CurrentTourQuestionsJSON" :key="questionIdx">
              <div v-if="!question.answered" class="question-wrapper">
                <h3>{{ question.t }}</h3>
                <div v-for="(answer, answerIdx) in question.a" :key="answerIdx" @click="toggleAnswer(question, answer)"
                  v-if="!answer.hidden">
                  <div class="answer-wrapper">
                    <div class="answer-text" v-if="!answer.hidden">
                      {{ answer.t }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <vs-button @click="$emit('ModeChanged', '')" v-if="false">Finish</vs-button>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>

      <a v-if="Mode == 'Tour'" @click="EndTour" class="text-danger" style="
          position: fixed;
          bottom: 20px;
          right: 20px;
          font-weight: 900;
          cursor: pointer;
          z-index: 9999;
        ">
        Exit tour
      </a>
    </div>

    <TCVelikContextMenuVue ref="embedContextMenu" style="min-width: 200px">
      <template>
        <div>
          <div class="embed-context-item">
            <a @click="EmbedDetails()">Open</a>
          </div>
          <div class="embed-context-item" v-if="IsOkrSection()">
            Show Dashboard
          </div>
          <div class="embed-context-item">
            <a @click="IsInEdit = true">Edit</a>
          </div>
          <div class="embed-context-item">
            <a @click="OpenLink(getImmersiveReaderPath())">PDF View</a>
          </div>
          <div class="embed-context-item">
            <a @click="ShareEmbed(getImmersiveReaderPath())">Share...</a>
          </div>
          <div class="embed-context-item">
            <a @click="AddEmbed()">Add Child</a>
          </div>
          <div class="embed-context-item">
            <a @click="AddCurrentUrlAsChildEmbed()">Add Current Page</a>
          </div>
          <div class="embed-context-item">
            <a class="text-danger" @click="DeleteEmbed()">Delete</a>
          </div>
        </div>
      </template>
    </TCVelikContextMenuVue>

    <div v-if="Mode == 'Immersive'" style="" id="immersive-wrapper">
      <div v-if="false" :style="'font-size:40px; font-weight:900;' + embedFilters &&
    embedFilters.length > 0
    ? 'margin-left:' + (embedFilters[0].Depth - 1) * 20 + 'px'
    : '0px'
    "></div>
      <div :class="'immersive-navigation ' + (ShowNavigation ? 'expanded' : 'collapsed')
    " style="">
        <EmbedImmersiveLink :EmbedFilters="embedFilters"></EmbedImmersiveLink>
      </div>

      <div class="immersive-content-wrapper">
        <EmbedImmersiveContent :EmbedFilters="embedFilters"></EmbedImmersiveContent>
      </div>
    </div>

    <div v-else-if="Mode != 'Tour'" id="embeds-main-screen" class="embed-main-screen">
      <FeatherIcon class="all-topics-menu" style="top:120px; right:20px" icon="MenuIcon"
        @click="TopicsMenuVisible = !TopicsMenuVisible">
      </FeatherIcon>
      <div style="background: white; min-height: 100%; padding: 20px" v-if="InDetails &&
    InternalDetailsItem &&
    InternalDetailsItem != null &&
    Mode !== 'Tour'
    ">
        <div class="embed-details">
          <h3 style="padding-bottom: 20px; font-size: 40px" v-if="!IsInEdit">
            {{ InternalDetailsItem.Title }}
          </h3>

          <vs-input class="title-editor" v-else v-model="InternalDetailsItem.Title"
            style="font-size:40px; font-weight: 500;">

          </vs-input>

          <tiptap v-model="InternalDetailsItem.Description" :editable="IsInEdit" @Publish="PublishEmbed()"
            @SaveDraft="Save(true)" @RevisionHistory="RevisionHistory()">
          </tiptap>

          <RelatedItemsDropdown @update:selectedItems="tagsUpdated" :selectedItems="InternalDetailsItem.RelatedTags"
            RelatedItemsType="DataModel.TCVelik.Taxonomy.TCTag" RelatedParentType="DataModel.TCVelik.Embed.TCEmbed"
            :RelatedParentId="InternalDetailsItem.Id" typeName="DataModel.TCVelik.Embed.TCEmbed"
            :GetItemsPromise="tagsService.getTags" :commitItemsPromise="tagsService.commitTags"></RelatedItemsDropdown>


          <div class="ql-editor" v-if="false" style="
              padding-left: 0px;
              padding-right: 0px;
              width: 100%;
              font-size: 21px;
            " v-html="InternalDetailsItem.Description"></div>

          <div v-if="IsCode(InternalDetailsItem) &&
    !this.$store.state.IsVisualStudio &&
    !InCodeMode
    " class="code-wrapper">
            <h3>&lt;/&gt; Code</h3>
            <br />
            Code is better viewed in the editor mode.<br />
            <a :href="InternalDetailsItem.ExploreUrl" target="_blank">Show in File Explorer</a>
          </div>
          <div style="margin-top: 10px; margin-bottom: 10px" v-if="InternalDetailsItem &&
    InternalDetailsItem.CalculatedSkills &&
    InternalDetailsItem.CalculatedSkills.length > 0
    ">
            <vs-collapse class="embed-skills">
              <vs-collapse-item>
                <div slot="header">
                  <div>
                    <StatusBar :Statuses="MassageCategories(InternalDetailsItem.CalculatedSkills)">
                    </StatusBar><br /><br /><br />
                    {{ InternalDetailsItem.CalculatedSkills.length }} skills
                    detected (click to expand)
                  </div>
                </div>
                <br />
                <div class="bg-primary text-white" style="padding: 20px">
                  <strong>Beta !!!</strong><br />
                  This feature does not yet calculate your scores for each
                  skill.
                </div>
                <br />
                <vs-table ref="table" pagination :data="InternalDetailsItem.CalculatedSkills">

                  <template slot="thead">
                    <vs-th sort-key="name">Name</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <tbody>
                      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td style="
                            v-align: top;
                            width: 250px;
                            vertical-align: top;
                          ">
                          <SkillExpandable style="margin-bottom: 10px" :Skill="tr" :key="indextr" HideTags="false">
                          </SkillExpandable>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </vs-collapse-item>
            </vs-collapse>
          </div>
          <!-- TODO - maybe we want to have an organism here for details and up for the tree... -->
        </div>
        <div class="navigate-topics" style="text-align: center; margin-top: 50px">
          <div v-if="InternalDetailsSiblingPrev" style="">
            <vs-button class="vs-button-border" style="cursor: pointer; width: 100%; margin-bottom: 10px"
              @click.stop="EmbedDetails(InternalDetailsSiblingPrev)">&lt;&lt; {{ InternalDetailsSiblingPrev.data.Title
              }}</vs-button>
          </div>
          <div v-if="InternalDetailsSiblingNext" style="">
            <vs-button class="vs-button-border" style="cursor: pointer; width: 100%; margin-bottom: 10px"
              @click.stop="EmbedDetails(InternalDetailsSiblingNext)">{{ InternalDetailsSiblingNext.data.Title }}
              >></vs-button>
          </div>
          <div v-if="InternalDetailsItem && IsTourStart(InternalDetailsItem)"
            style="cursor: pointer; width: 100%; margin-bottom: 10px">
            <vs-button class="vs-button-primary" style="cursor: pointer; width: 100%" @click="TourMode()">Tour with
              quiz</vs-button>
          </div>
          <div>
            <vs-button class="vs-button-primary" style="cursor: pointer; width: 100%" @click="AssessMe()">Quick
              assessment</vs-button>
          </div>
        </div>
        <div style="clear: both; margin-bottom: 10px"></div>
        <br /><br />
        <vs-collapse class="embed-actions">
          <vs-collapse-item>
            <div slot="header">
              <FeatherIcon icon="CheckCircleIcon" style="
                  width: 16px;
                  height: 16px;
                  float: left;
                  display: inline-block;
                  margin-right: 15px;
                "></FeatherIcon>
              <span>Prerequisites</span>&nbsp;<span v-if="CurrentPrerequisites && CurrentPrerequisites.length > 0"
                style="">({{ CurrentPrerequisites != null && CurrentPrerequisites.length > 0 }} prereqs)</span>
            </div>
            <PrerequisiteTable @PrerequisitesAdded="RefreshPrereqs" :Prerequisites="CurrentPrerequisites"
              :AnalyzedArticle="InternalDetailsItem" :ForUser="currentUser.User"
              :SourceType="'DataModel.TCVelik.Embed.TCEmbed'" :RelationType="'Prerequisite'"
              :SourceItemId="InternalDetailsItem.Id">
            </PrerequisiteTable>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">
              <FeatherIcon icon="CheckCircleIcon" style="
                  width: 16px;
                  height: 16px;
                  float: left;
                  display: inline-block;
                  margin-right: 15px;
                "></FeatherIcon>
              Onboarded
              <span v-if="OnboardedPeople">{{
    OnboardedPeople.length
  }}</span>
            </div>
            <div v-if="OnboardedPeople">
              <vs-table ref="table" :data="OnboardedPeople">

                <template slot="thead">
                  <vs-th> </vs-th>
                  <vs-th sort-key="FullName">User</vs-th>
                  <vs-th sort-key="Comment">Comment:</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="'ob_' + indextr" v-for="(tr, indextr) in OnboardedPeople">
                      <vs-td style="v-align: top; vertical-align: top">
                        <UserAvatar :userProfile="tr.CreatedForUser" size="32px" color="primary" styleProp="float:left;"
                          :MarkExEmployees="true">
                        </UserAvatar>
                      </vs-td>
                      <vs-td style="v-align: top; vertical-align: top">
                        <p class="product-name font-medium">
                          {{ tr.CreatedForUser.FirstName }}
                          {{ tr.CreatedForUser.LastName }}<br />
                          <small><small><strong>{{ tr.AssignmentType }}</strong></small></small><br /><span
                            style="font-size: 9px">{{
    friendlyDate(tr.CreatedOn)
  }}</span>
                        </p>
                      </vs-td>
                      <vs-td>
                        {{ tr.Comment }}
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">
              <FeatherIcon icon="CheckCircleIcon" style="
                  width: 16px;
                  height: 16px;
                  float: left;
                  display: inline-block;
                  margin-right: 15px;
                "></FeatherIcon>Help &amp; Feedback (0 open)
            </div>
            <a @click="GiveFeedback()"> Give feedback </a>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">
              Tags and Links ({{ InternalDetailsItem.RelatedTags.length }} tags)
            </div>
            <TagList :tags="InternalDetailsItem.RelatedTags"> </TagList><br />
            <a :href="InternalDetailsItem.ExploreUrl" target="_blank">Open in new window</a>
          </vs-collapse-item>
          <vs-collapse-item>
            <div slot="header">Progress, Ownership, Assignments</div>
            <div v-if="AssignmentData && AssignmentData.length > 0">
              <vs-table ref="table" :data="AssignmentData">

                <template slot="thead">
                  <vs-th> </vs-th>
                  <vs-th sort-key="FullName">User</vs-th>
                  <vs-th sort-key="Comment">Comment:</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in AssignmentData">
                      <vs-td style="v-align: top; vertical-align: top">
                        <UserAvatar :userProfile="tr.CreatedForUser" size="32px" color="primary"
                          styleProp="float:left;">
                        </UserAvatar>
                      </vs-td>
                      <vs-td style="v-align: top; vertical-align: top">
                        <p class="product-name font-medium">
                          {{ tr.CreatedForUser.FirstName }}
                          {{ tr.CreatedForUser.LastName }}<br />
                          <small><small><strong>{{ tr.AssignmentType }}</strong></small></small><br /><span
                            style="font-size: 9px">{{
    friendlyDate(tr.CreatedOn)
  }}</span>
                        </p>
                      </vs-td>
                      <vs-td>
                        {{ tr.Comment }}
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
            <div style="clear: both"></div>
            <br />
            <a @click.stop="IsEditEmbedActive(true)" style="cursor: pointer">Edit</a>&nbsp;
            <a @click.stop="Assign" style="cursor: pointer">Assign</a>
            &nbsp;
            <a @click.stop="MarkComplete(InternalDetailsItem)" style="cursor: pointer">Mark completed</a>
          </vs-collapse-item>
        </vs-collapse>
      </div>
      <div class="overview-card-wrapper" v-else-if="!InternalDetailsItem && Mode != 'Tour' && !TriggerUrl">
        <div>
          <OverviewCard :TriggerUrl="TriggerUrl" v-if="embedFilters && embedFilters.length > 0 && !IsLoading" :ProjectId="ProjectId"
            :ForUser="currentUserId"></OverviewCard>
        </div>
      </div>
      <div style="max-width: 300px">
        <div>
          <AddEditEmbedPopup v-if="EditInternal && InternalDetailsItem && InternalDetailsItem != null
    " :UpdateActive="IsEditEmbedActive" :currentItem="InternalDetailsItem" :isActive="EditInternal"
            :AllowEmbedNotifications="AllowEmbedNotifications" :AllowNotifyChecked="AllowNotifyChecked"
            :EmailsToNotify="EmailsToNotify" :Save="Save" :IsSidePopUp="true" :ParentNode="editParentNode"
            :TriggerUrl="TriggerUrl" ref="addEditEmbedWindow">
          </AddEditEmbedPopup>
        </div>
        <div>
          <AssignmentEditor v-if="InternalDetailsItem && InternalDetailsItem.Id" :isActive="isAssignmentEditing"
            :update:active="isAssignmentUpdated" :currentItem="InternalDetailsItem" :UpdateActive="isAssignmentUpdated"
            :Save="SaveAssignment" :ItemId="InternalDetailsItem.Id" ItemType="DataModel.TCVelik.Embed.TCEmbed"
            ShowAssignmentTypes="true" :PreselectedAssignmentType="currentAssignmentType"
            :PreselectedUsers="CurrentItemOwner">
          </AssignmentEditor>
        </div>
      </div>
    </div>
    <div v-show="TopicsMenuVisible == true || !InHamburgerMode" ref="treeholder" class="tree-holder" :style="'background: white; top: 70px; left: 820px; padding:30px' +
    (!InCodeMode ? 'position: absolute;' : '')
    ">
      <!-- Brutal reload hack. -->
      <div v-if="false" style="background: white">
        <a style="cursor: pointer; float: right; margin-left: 20px" @click.stop="BackToList()">All Items</a>
        <a @click.stop="CopyWindowLink()" style="cursor: pointer; float: right; margin-left: 20px">Permalink</a>
        <a @click.stop="IsEditEmbedActive(true)" style="cursor: pointer; float: right">Edit</a>
      </div>

      <div style="display: none">
        <vs-input v-model="embedSearchFilter" class="ide-text" placeholder="Type to search ..." icon="icon-search"
          icon-pack="feather" style="display: block; width: 100%; padding: 10px" size="sm" />
        &nbsp;<a href="/pages/context-and-onboarding" style="float: right; margin-left: 20px">Back to all tours</a>
        <a @click.stop="CopyWindowLink()" style="cursor: pointer; float: right; margin-left: 20px">Permalink</a>

        <a @click.stop="AddEmbed()" style="padding-left: 10px; cursor: pointer">Add new</a>
      </div>
      <h2 v-if="(InternalDetailsItem == null &&
    Mode != 'Immersive' &&
    !isInEmbedMode &&
    !IsLoading) && (!embedFilters && embedFilters.length == 0 && !IsLoading)
    " style="padding: 30px;">
        Explore all articles:
      </h2>
      <div v-if="embedFilters && embedFilters.length == 0 && !IsLoading"
        style="background: white; margin-top: 20px; padding: 10px">
        <div style="margin-top: 40px">
          <h3>No guides.</h3>
          There seem to be no guides for this project.<br /><br />
          Start guide by opening files and mapping the key points in TCVelik
          explorer or in Visual Studio.
          <br />
          <a @click.stop="AddEmbed()" style="font-size: 1.5em; cursor: pointer">Add new</a>
        </div>
      </div>

      <LiquorTree v-if="embedFilters &&
    embedFilters.length > 0 &&
    Mode != 'Tour' &&
    Mode != 'Immersive' &&
    !isInEmbedMode
    " :options="treeOptions" class="embed-filter-tree" ref="tourTree" @node:dragging:start="EmbedDragStart"
        @node:dragging:finish="EmbedDragFinish" @node:selected="selectionChanged" :data="embedFilters"
        :filter="embedSearchFilter" @contextmenu="$refs.embedContextMenu.open($event)">
        <div slot-scope="{ node }" class="node-container" :style="GetEmbedStyle(node)" @contextmenu.prevent="
    setCurrentContextMenuItem(node);
  $refs.embedContextMenu.open($event);
  ">
          <vs-icon icon-pack="feather" :icon="GetIconForItem(node)" size="medium"
            style="font-size: 24px; margin-right: 5px; float: left">
          </vs-icon>
          <div @click.exact="setCurrentContextMenuItem(node)" class="node-text"
            style="float: left; width: calc(100% - 40px)">
            {{ node.data.Title || "NO EMBED TITLE!!!" }}
            <div v-if="true">

            </div>
            <div style="font-size: 0.7em; float: right; display: none">
              <a @click.stop="AddEmbed(node)" style="margin-right: 10px">
                Add child
              </a>
              <a class="text-danger" style="cursor: pointer" @click.stop="DeleteEmbed(node)">Delete</a>&nbsp;
            </div>
          </div>
        </div>
      </LiquorTree>
    </div>
  </div>
</template>

<script>
import EmbedsService from "@/embeds/embedService.js";
import LiquorTree from "liquor-tree";
import TagList from "@/views/components/extra-components/taglist/TagList.vue";
import AddEditEmbedPopup from "@/views/components/extra-components/embededitor/AddEditEmbedPopup.vue";
import AssignmentEditor from "@/views/components/extra-components/assignments/AssignmentEditor.vue";
import AssignmentService from "@/assignments/assignmentsService.js";
import StatusBar from "@/views/components/organisms/StatusBar.vue";
import SkillExpandable from "@/views/components/extra-components/skills/SkillExpandable.vue";
import Textarea from "../../../forms/form-elements/textarea/Textarea.vue";
import EmbedImmersiveLink from "@/views/components/organisms/embeds/embeds-immersive/EmbedImmersiveLink.vue";
import EmbedImmersiveContent from "@/views/components/organisms/embeds/embeds-immersive/EmbedImmersiveContent.vue";
import UserAvatar from "@/views/components/extra-components/users/UserAvatar.vue";
import TCVelikContextMenuVue from "@/views/components/organisms/contextmenu/TCVelikContextMenu.vue";
import OverviewCard from "@/views/pages/OverviewCard.vue";
import SwiperTour from "@/views/components/organisms/swiper-tour/SwiperTour.vue";
import PrerequisiteTable from "@/views/components/organisms/prerequisites/PrerequisiteTable.vue";
import moment from "vue-moment";

import "swiper/dist/css/swiper.min.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import FeatherIcon from "../../../../components/FeatherIcon.vue";
import EmbedUtils from "./utils/EmbedUtils.js";
import TourUtils from "./utils/TourUtils.js";
import AssignemntUtils from "./utils/AssignmentUtils.js";
import AsessmentUtils from "./utils/AsessmentUtils.js";

import SwiperDataUtils from "./dataregions/SwiperDataUtils.js";
import EmbedDataUtils from "./dataregions/EmbedDataUtils.js";
import relationsService from "@/relations/relationsService.js";

import AssessmentScreen from "@/views/components/organisms/assessments/AssessmentScreen.vue";

import tiptap from "@/views/components/extra-components/editors/tiptap.vue";

import TagsService from "@/tags/tagsService.js";
import RelatedItemsDropdown from "@/views/components/extra-components/RelatedItems/RelatedItemsDropdown.vue";

import OpenAIClient from "@/openai/OpenAIClient.js";

import ShareEmbedSteps from "@/views/components/organisms/embeds/share/ShareEmbedSteps.vue";
  
import accountsService from "../../../../accounts/accountsService";

export default {
  data() {
    return {
      tagsService: TagsService,
      ...SwiperDataUtils,
      ...EmbedDataUtils,
      IsInEdit: false,
      SideBarActive: false,
      IsLoading: true,
      ExpandedList: false,
      currentDragnode: null,
      lastDragParent: null,
      lastDragIndex: null,
      editParentNode: null,
      embedSearchFilter: "",
      isAssignmentEditing: false,
      treeUpdateCounter: 1,
      hackReloadCard: false,
      InDetails: false,
      EditInternal: false,
      treeKey: 1,
      PathToOpen: null,
      ContextMenuItem: null,
      AssignmentData: [],
      OnboardedPeople: [],
      ShowNavigation: false,
      LastTopicTimeout: null,
      currentUser: null,
      currentUserId: null,
      CurrentItemOwner: null,
      embed: null,
      isInEmbedMode: false,
      currentAssignmentType: null,
      TopicsMenuVisible: false,
      InHamburgerMode: false,
      CurrentPrerequisites: null,
      RevisionHistoryItems: null,
      ShowRevisionHistory: false,
      ShowPublishOptions: false,
      ShouldExpand: false,
      RevisionComment: "",
      ResetAssessments: true,
      ShowShareOptions: false,
    };
  },
  mounted() {
    var instance = this;

    window.onresize = function () {
      instance.resized();
    };

    instance.resized();

    if (this.$route.query.inEmbed && this.$route.query.inEmbed == "true") {
      this.isInEmbedMode = true;
    }

    this.$set(
      this,
      "currentUser",
      accountsService.getUserFromLocalStorage()
    );

    this.$set(this, "currentUserId", this.currentUser.User.Id);

    this.$set(
      this,
      "InDetails",
      this.$route.query.eid && this.$route.query.eid.length
    );
    this.$set(this, "IsLoading", true);

    this.LoadEmbeds();

    document.addEventListener('keydown', function (event) {
      if (event.ctrlKey && event.key === 's') {
        event.preventDefault();
        if (instance.InternalDetailsItem != null) {
          instance.Save(true);
        }
      }
    });

  },
  methods: {
    ...EmbedUtils,
    ...TourUtils,
    ...AssignemntUtils,
    ...AsessmentUtils,
    RefreshPrereqs(newPrereqs) {
      this.CurrentPrerequisites = [...newPrereqs];
    },
    RevisionHistory() {
      var instance = this;
      EmbedsService.getItemRevisionHistory(this.InternalDetailsItem.Id).then(function (response) {
        instance.$set(instance, "RevisionHistoryItems", response.data.Items);
        instance.$set(instance, "ShowRevisionHistory", true);
      });
    },
    PublishRevision() {
      var originalItem = this.InternalDetailsItem;
      var instance = this;
      var comment = this.RevisionComment;
      var version = this.InternalDetailsItem.VersionHistory[0];
      EmbedsService.publishRevision(comment, version.Id).then(function () {

        OpenAIClient.resetAICacheForDocumentAssessment(originalItem.Id);

        instance.LoadEmbeds();
        instance.ShowPublishOptions = false;
        instance.RevisionComment = ''
        instance.$vs.notify({
          title: "Success",
          text: `${originalItem.Title} published successfully.`,
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          time: 5000,
        });
      });
    },
    friendlyDate(date) {
      const moment = require("moment");
      return moment(date).fromNow();
    },
    resized: function () {
      var spaceHolder = document.querySelector(".router-view");
      if (spaceHolder) {
        if (spaceHolder.clientWidth < 1000) {
          spaceHolder.classList.add("hamburger");
          this.InHamburgerMode = true;
        } else {
          this.InHamburgerMode = false;
          spaceHolder.classList.remove("hamburger");
        }
      }
    },
    tagsUpdated(newVal) {
      this.$set(this.InternalDetailsItem, "RelatedTags", newVal);
    },
    toggleAnswer(question, answer, win) {
      var minAttempts = this.CurrentTourQuestionsJSON.length - 1;
      var attempts = this.AnswerAttempts;

      win = win || window;

      if (win) {
        win.scrollTo(0, 0);
      }

      if (answer.c) {
        this.QuestionsAnswered++;
        this.$set(question, "answered", true);
      } else {
        alert("Ok, this wasn't quite it.\nLet's try again.");
        this.$set(answer, "hidden", true);
      }

      AssignmentService.assignTopicQuizAnswer(
        question.tid,
        "DataModel.TCVelik.Embed.TCEmbed",
        answer.c
      );
    },
    SlideChanged(win) {
      var instance = this;
      var index = this.$refs.swiper.swiper.realIndex;

      win = win || window; //.scrollY(0);

      win.scrollTo(0, 0);

      try {
        if (
          win.chrome &&
          win.chrome.webview &&
          win.chrome.webview.postMessage
        ) {
          win.chrome.webview.postMessage({
            op: "OPEN_EMBED",
            arg: this.ContextMenuItem.children[index].data,
          });
        }
      } catch (err) {
        console.error("[EMBED LOAD FAILED]", err);
      }

      if (index < this.ContextMenuItem.children.length) {
        var embed = this.ContextMenuItem.children[index];
        EmbedsService.getItem(embed.data.Id).then(function (response) {
          instance.$set(embed.data, "Description", response.data.Description);
          instance.$nextTick(function () {
            instance.SetReadTimer(win);
            win.scrollTo(0, 0);
          });
        });
      } else if ((index = this.ContextMenuItem.children.length - 1)) {
        this.GenerateQuestions();
      }
    },
    SetReadTimer(win) {
      win = window || win;

      var instance = this;

      if (instance.LastTopicTimeout) {
        win.clearTimeout(instance.LastTopicTimeout);
      }

      var readTimerTimeout = win.setTimeout(function () {
        instance.RegisterTopicRead();
      }, 10000);

      instance.$set(instance, "LastTopicTimeout", readTimerTimeout);
    },
    RegisterTopicRead() {
      var instance = this;
      try {
        AssignmentService.assignTopcReadForCurrentUser(
          instance.ContextMenuItem.data.Id,
          "DataModel.TCVelik.Embed.TCEmbed"
        ).then(function () { });
      } catch (err) {
        console.log("Error saving item ...", err);
      }
    },

    OpenLink(url) {
      window.open(url);
    },
    ShareEmbed() {
      this.$set(this, "ShowShareOptions", true);
    },
    preventRest() { },
    selectionChanged(node) {
      this.$emit("SelectionChanged", node);
      this.$set(this, "ContextMenuItem", node);
      this.EmbedDetails();
    },
    GetFontSize(embed) {
      var normalizationFactor = this.embedFilters[0].Data.Depth;
      return 40 - (embed.Data.Depth - normalizationFactor) * 5 + "px";
    },
    GetLeftMarginImmersive(embed) {
      var normalizationFactor = this.embedFilters[0].Data.Depth;
      return 30 + (embed.Data.Depth - normalizationFactor) * 30 + "px";
    },

    MassageCategories(items) {
      return [
        {
          CurrentItemsState: "Negative",
          ClassSuffix: "danger",
          CurrentItemsCount: 0,
          ToolTip:
            "Indicates that the skill is negatively scored and needs attention",
          TotalItems: 0,
        },
        {
          CurrentItemsState: "Not Started",
          ClassSuffix: "unset",
          CurrentItemsCount: items.length,
          ToolTip: "The skill was either not started or nullified later on.",
          TotalItems: items.length,
        },
        {
          CurrentItemsState: "In Progress",
          ClassSuffix: "warning",
          CurrentItemsCount: 0,
          ToolTip: "The skill is in progress, but not acquired yet.",
          TotalItems: items.length,
        },
        {
          CurrentItemsState: "Completed",
          ClassSuffix: "success",
          CurrentItemsCount: 0,
          ToolTip: "The skill is acqiured.",
          TotalItems: items.length,
        },
        {
          CurrentItemsState: "Can Coach",
          ClassSuffix: "coach",
          CurrentItemsCount: 0,
          ToolTip: "The person can train other people on this skill.",
          TotalItems: items.length,
        },
      ];
    },
    BackToList() {
      this.$set(this, "InternalDetailsItem", null);
      this.$set(this, "InDetails", false);
      this.$set(this, "CurrentPrerequisites", null);
    },

    getAreaPath() {
      if (this.ContextMenuItem && this.ContextMenuItem.data) {
        return (
          "/dashboard/explorer-immersive/" +
          this.ContextMenuItem.data.AccountId +
          "/" +
          this.ContextMenuItem.data.ProjectId +
          "/na/1/1/1/1/HEAD/na" +
          "?aid=" +
          this.ContextMenuItem.data.EmbedFullArea +
          "/"
        );
      }
    },
    TopicLink(nodeToUse) {
      window.location.href = "/external/addeditembed?eid=" + nodeToUse.data.Id;
    },
    getImmersiveReaderPath() {
      var realArea = this.getAreaPath(this.ContextMenuItem);
      var replaced = realArea.replace("/explorer/", "/explorer-immersive/");
      return replaced;
    },
    GetCurrentUserState(node) {
      var assignments = node.data.EmbedObject.AllAssignments;
      if (assignments && assignments.length > 0) {
        var assignmentState = assignments[0].State;
        return assignmentState;
      }
      return -1;
    },
    CopyWindowLink() {
      var instance = this;
      this.$copyText(window.location.href).then(
        function () {
          instance.$vs.notify({
            title: "Success!",
            text: "Link copied to clipboard.",
            color: "success",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-check-circle",
          });
        },
        function () {
          instance.$vs.notify({
            title: "Failed!",
            text: "Error copying link.",
            color: "danger",
            iconPack: "feather",
            position: "top-center",
            icon: "icon-alert-circle",
          });
        }
      );
    },
  },
  watch: {
    IsEdit(newVal) {
      this.$set(this, "EditInternal", newVal);
      if (!newVal) {
        this.$emit("EmbedEditExit", true);
      }
    },
    DetailsItem(newVal) {
      if (
        (!newVal.EmbedArea ||
          newVal.EmbedArea == null ||
          newVal.EmbedArea == "") &&
        (!newVal.Id || newVal.Id < 1)
      ) {
        newVal.EmbedArea = this.ContextMenuItem.data.EmbedFullArea;
      }

      this.$set(this, "InternalDetailsItem", newVal);
      this.$set(this, "CurrentPrerequisites", newVal);

      this.SetEmbedStatistics();

    },
    ProjectId() {
      this.$set(this, "hackReloadCard", false);
      this.$set(this, "hackReloadCard", true);
      this.LoadEmbeds();
    },
    InternalDetailsItem(newVal) {
      var instance = this;
      if (newVal && newVal && newVal.Id) {
        instance.$nextTick(function () {
          var nodeToExpandResult = instance.$refs.tourTree.find({
            data: {
              Id: newVal.Id,
            },
          });

          if (nodeToExpandResult && nodeToExpandResult.length == 1) {
            var nodeToStartWith = nodeToExpandResult[0];

            if (!instance.EidShown) {
              nodeToStartWith.expand();
              nodeToStartWith.select();

              var parent = nodeToStartWith;
              while (parent && parent != null) {
                if (!parent.states.expanded) {
                  parent.expand();
                }
                parent = parent.parent;
              }
            }

            this.SetPreviousTopic(nodeToStartWith);
            this.SetNextTopic(nodeToStartWith);

            instance.SetReadTimer();

            relationsService
              .get(
                'SourceType="DataModel.TCVelik.Embed.TCEmbed" && SourceItemId=' +
                this.InternalDetailsItem.Id,
                0,
                20000000
              )
              .then(function (response) {
                instance.$set(instance, "CurrentPrerequisites", response.data);
              });
          }
        });
      } else {
        instance.$set(instance, "InternalDetailsSiblingNext", null);
        instance.$set(instance, "InternalDetailsSiblingPrev", null);
      }
    },
  },
  computed: {
    flatTree() {
      function flattenTree(node) {
        const result = [];
        result.push(node);
        node.Children.forEach((child) => {
          result.push(...flattenTree(child));
        });
        return result;
      }
      return flattenTree(this.embedFilters);
    },
  },
  components: {
    LiquorTree,
    TagList,
    AddEditEmbedPopup,
    AssignmentEditor,
    StatusBar,
    SkillExpandable,
    Textarea,
    EmbedImmersiveLink,
    EmbedImmersiveContent,
    UserAvatar,
    TCVelikContextMenuVue,
    swiper,
    swiperSlide,
    // Sidebar,
    FeatherIcon,
    OverviewCard,
    SwiperTour,
    AssessmentScreen,
    PrerequisiteTable,
    RelatedItemsDropdown,
    moment,
    tiptap,
    ShareEmbedSteps
  },
  props: [
    "ProjectId",
    "DetailsItem",
    "IsEdit",
    "AllowEmbedNotifications",
    "AllowNotifyChecked",
    "EmailsToNotify",
    "Mode",
    "SelectedNode",
    "InCodeMode",
    "TriggerUrl",
  ],
};
</script>

<style scoped>
*>>>.title-editor {
  width: 100%;
  margin-bottom: 20px;
}

*>>>.title-editor input {
  font-size: 40px !important;
  width: 100%;
  border: 0px solid white;
  font-weight: 500 !important;
}

*>>>.vs-collapse-item.open-item .vs-collapse-item--content {
  max-height: none !important;
}

.router-view.hamburger .tree-holder {
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  width: 100% !important;
  height: 100% !important;
}

*>>>.swiper-slide-active li {
  /* list-style: auto !important;
  margin-bottom: 10px !important;
  background: #efefef !important;
  padding: 10px !important;
  list-style-position: inside !important; */
}

.router-view.hamburger .all-topics-menu {
  position: absolute !important;
  top: 20px;
  right: 20px;
  display: block !important;
  z-index: 9999;
  cursor: pointer;
}

.tree-holder {
  display: block;
}

.all-topics-menu {
  display: none;
}

*>>>.overview-card-wrapper {
  min-width: 800px;
}

*>>>.embed-details {
  font-size: 1.2em;
}

*>>>.embed-details img {
  max-width: 100%;
}

*>>>.node-container {
  padding-top: 0px;
  min-width: 90%;
}

*>>>.tree-anchor {
  line-height: unset !important;
}

*>>>.tree-checkbox {
  flex-shrink: 0;
  position: relative;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  border: 1px solid #dadada;
  border-radius: 2px;
  background: #fff;
  transition: border-color 0.25s, background-color 0.25s;
}

*>>>.tree-checkbox.checked,
*>>>.tree-checkbox.indeterminate {
  background-color: #8bc34a;
  border-color: #8bc34a;
}

*>>>.tree-checkbox.checked:after {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  border: 1.5px solid #fff;
  border-left: 0;
  border-top: 0;
  left: 6px;
  top: 1px;
  height: 7px;
  width: 4px;
  -webkit-transition: -webkit-transform 0.25s;
  transition: -webkit-transform 0.25s;
  transition: transform 0.25s;
  transition: transform 0.25s, -webkit-transform 0.25s;
  -webkit-transform-origin: center;
  transform-origin: center;
}

*>>>.embed-skills .vs-collapse-item--header {
  padding-left: 10px;
  background: #efefef;
  font-size: 0.7em;
  font-weight: bold;
}

*>>>.explorer-context-menu li a {
  cursor: pointer;
}

*>>>.embed-filter-tree {
  margin-top: 30px;
  margin-left: 20px;
  overflow: hidden;
}

*>>>.embedContextMenu>div>a:hover,
*>>>.embedContextMenu>div>a:focus {
  color: white !important;
  cursor: pointer !important;
}

*>>>.embed-skills {
  padding-left: 0px;
}

*>>>.embed-skills .con-content--item {
  height: auto;
  padding-bottom: 20px;
}

*>>>.hover-only {
  display: none;
}

*>>>.node-text:hover .hover-only {
  display: block;
}

*>>>.embed-actions {
  padding: 0px !important;
}

*>>>.embed-actions header {
  font-size: 1em;
  font-weight: 400;
  background: #efefef;
  margin-bottom: 3px;
}

*>>>.embed-actions a {
  font-size: 1em;
  font-weight: 400;
}

*>>>.embed-actions .tag {
  font-size: 1em !important;
  font-weight: 400;
}

*>>>.ql-editor ol li {
  margin-bottom: 20px !important;
  margin-top: 20px;
}

*>>>.immersive-navigation {
  margin-bottom: 100px;
  position: fixed;
  left: 0px;
  top: 0px;
  max-width: 350px;
  background: white;
  overflow: scroll;
  height: 100%;
  border-right: 1px solid black;
}

*>>>.immersive-content-wrapper {
  margin-left: 450px;
  max-width: 1100px;
}

@media screen and (max-width: 1024px) {
  *>>>.overview-card-wrapper {}

  *>>>.embed-filter-tree {
    margin-top: 8em !important;
  }

  *>>>.immersive-navigation.collapsed {
    display: none;
  }

  *>>>.immersive-navigation.expanded {
    display: none;
  }

  *>>>.immersive-content-wrapper {
    margin-left: 50px;
    max-width: 700px;
  }

  *>>>.embeds-main-screen {
    padding: 10px;
    max-width: 100% !important;
  }
}
</style>

<style scoped>
*>>>.embed-context-item {
  border-bottom: 1px solid #efefef !important;
}

*>>>.embed-context-item a {
  padding: 10px !important;
  width: 100%;
  height: 100%;
  display: block;
  cursor: pointer !important;
}

*>>>.embed-context-item a:hover {
  background: #633c92 !important;
  color: white !important;
}
</style>

<style scoped>
.embed-main-screen {
  max-width: 800px;
  float: left;
  min-width: 800px;
}

.hamburger .embed-main-screen {
  min-width: auto !important;
  max-width: 100% !important;
}

.swiper-wrapper {
  height: auto !important;
  max-height: 50%;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next,
.swiper-button-next {
  position: fixed !important;
  left: auto;
}

.carousel-example .swiper-container .swiper-slide {
  margin-top: 0px;
  padding: 60px;
  align-items: center;
  font-size: 1.5rem;
}

.question-wrapper {
  padding: 20px;
  border-radius: 20px;
  margin-bottom: 10px;
  color: var(--secondary);
}

.hamburger .question-wrapper h3 {
  font-size: 1.2em !important;
  margin-bottom: 30px;
}

.hamburger .answer-text {
  font-size: 0.8em !important;
}

.question-wrapper h3 {
  color: var(--primary);
  font-weight: 900;
  font-size: 1.7em;
  margin-bottom: 50px;
}

.answer-wrapper {
  width: 100%;
  display: block;
  padding: 5px;
  margin: 5px;
  cursor: pointer;
  border: 1px solid var(--primary);
  color: var(--primary);
  border-radius: 10px;
}

.code-wrapper {
  margin-top: 50px;
  margin-bottom: 50px;
  padding: 20px;
  border: 1px solid #acacac;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: var(--primary)
}
</style>
